import none from "./none.js";

export default function(series) {
  return none(series).reverse();
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-shape/src/order/reverse.js
// module id = ./node_modules/d3-shape/src/order/reverse.js
// module chunks = 53